// extracted by mini-css-extract-plugin
module.exports = {"button":"empty-groups_button__3TpCo","smallText":"empty-groups_smallText__18rPU"};